import { render, staticRenderFns } from "./releaseAppDialog.vue?vue&type=template&id=1a2d11c4&scoped=true"
import script from "./releaseAppDialog.vue?vue&type=script&lang=js"
export * from "./releaseAppDialog.vue?vue&type=script&lang=js"
import style0 from "./releaseAppDialog.vue?vue&type=style&index=0&id=1a2d11c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2d11c4",
  null
  
)

export default component.exports